// 验证字符串是否为空
// ture 说明为空  false 说明不为空
export function isEmptyString(string) {
    if (
        string == undefined ||
        typeof string == "undefined" ||
        !string ||
        string == null ||
        string == "" ||
        /^\s+$/gi.test(string)
    ) {
        return true;
    } else {
        return false;
    }
}

//获取两个特定字符串之间的字符，支持匹配多段字符
export function getStrBetween(str, starStr, endStr) {
    let split1Array = str.split(endStr);
    let split2Array = [];
    for (let i = 0; i < split1Array.length; i++) {
        let str1 = split1Array[i];
        if (str1.indexOf(starStr) != -1) {
            let split3Array = str1.split(starStr);
            if (split3Array.length > 0) {
                let str2 = split3Array[split3Array.length - 1];
                split2Array.push(str2);
            }
        }
    }
    return split2Array;
}

//手机号校验
export function validatePhoneNumber(str) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return reg.test(str);
}
//手机号或电话校验
export function validatePhTelNumber(str) {
    const reg =
        /^((\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14})|([1][3,4,5,6,7,8,9][0-9]{9})$/;
    return reg.test(str);
}
//邮箱校验
export function validateEmail(str) {
    const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    return reg.test(str);
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = "";
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && value !== "" && typeof value !== "undefined") {
            if (typeof value === "object") {
                for (const key of Object.keys(value)) {
                    if (
                        value[key] !== null &&
                        value[key] !== "" &&
                        typeof value[key] !== "undefined"
                    ) {
                        let params = propName + "[" + key + "]";
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result;
}

/**
 * 将HTML字符串转换为纯文本格式。
 * @param {string} html - 待转换的HTML字符串。
 * @return {string} 转换后的纯文本。
 */
export function toText(html) {
    // 移除所有的HTML标签
    return html
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
        .replace(/<[^>]+?>/g, "")
        .replace(/\s+/g, " ")
        .replace(/ /g, " ")
        .replace(/>/g, " ");
}
//打包时此处修改
export function completeUrl(url) {
    if (url && url.indexOf("http://") == -1 && url.indexOf("https://") == -1) {
        // url =
        //   window.location.protocol +
        //   "//" +
        //   window.location.hostname +
        //   ":8091" +
        //   url;
        // url = "http://192.168.0.128:8091" + url;
        url = "https://hnkczx.cn:8080" + url;
    }
    return url;
}